import React, { useContext, useEffect, useState } from 'react'
import './Signup.css'
import User from '../../imgs/userlogo.png';
import Grade from '../../imgs/gradelogo.png';
import Language from '../../imgs/language.png';
import Bdate from '../../imgs/bdate.png';
import Gender from '../../imgs/gender.png';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import Globalcontext from '../../Context/Globalcontext';

const Signup = () => {
    const a = useContext(Globalcontext);
    const { state } = useLocation();
    const [input, setInput] = useState({ sname: "",dob: "",grade: "",language: "",gender:"" })
    const notifyerror = (msg) => toast.error(msg);
    const notifysuccess = (msg) => toast.success(msg);
    const navigate = useNavigate();
    const handleChange = (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }
    useEffect(()=>{
        if(localStorage.getItem("gllogin") === ''){
            navigate('/studentiqtest'); 
        }
      })

    function Capitalize(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    const handlesignup = ()=>{
       
        if(input.sname == "" || input.dob == "" || input.grade == "Select Grade" || input.language == "Select Language" || input.gender == "Select Gender" )
        {
            notifyerror("Please fill all information");
        }
        else{
            Signup();
        }
    }

    const Signup = ()=>{
        let rawData = {
            sname: input.sname,
            mobno: state.mobno1,
            datesend: "",
            language: input.language,
            bdate: input.dob,
            gender: input.gender,
            grade: input.grade,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData);

        axios.post('https://softtesting.in/iniqtest/cust/studentpanel/signup.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            if(response.data === "Saved")
            {
                    a.setSname(input.sname);
                    a.setGrade(input.grade);
                    a.setDob(input.dob);
                    a.setGender(input.gender);

                    notifysuccess(`Welcome ${input.sname}`);
                    navigate('/Dashboard');
            }
        }).catch(err => {
            console.log(err);
        });
    }
    return (
        <div className='signup'>
            <div className="whiteboxsignup">
                <span >Lets Test and enhance your IQ Score</span>
                <div className="form">
                    <div className="rowsignup">
                        <img src={User} alt="" />
                        <input type="text" id="sname" name="sname" placeholder='Student Name' value={Capitalize(input.sname)} onChange={handleChange} />
                    </div>
                    <div className="rowsignup">
                        <img src={Bdate} alt="" />
                        <input maxLength="10" type="date" id="dob" name="dob" value={input.dob} onChange={handleChange} />
                    </div>
                    <div className="rowsignup">
                        <img src={Grade} alt="" />
                        <select name="grade" id= "grade" value={input.grade} onChange={handleChange} className="form-select" aria-label="Select Grade">
                            <option defaultValue="Select Grade">Select Grade</option>
                            <option value="CLASS - 1">CLASS - 1</option>
                            <option value="CLASS - 2">CLASS - 2</option>
                            <option value="CLASS - 3">CLASS - 3</option>
                            <option value="CLASS - 4">CLASS - 4</option>
                            <option value="CLASS - 5">CLASS - 5</option>
                            <option value="CLASS - 6">CLASS - 6</option>
                            <option value="CLASS - 7">CLASS - 7</option>
                            <option value="CLASS - 8">CLASS - 8</option>
                            <option value="CLASS - 9">CLASS - 9</option>
                            <option value="CLASS - 10">CLASS - 10</option>
                            <option value="CLASS - 11">CLASS - 11</option>
                            <option value="CLASS - 12">CLASS - 12</option>
                            <option value="Under Graduates">Under Graduates</option>
                            <option value="Post Graduates">Post Graduates</option>
                            <option value="Professionals">Professionals</option>

                        </select>
                    </div>

                    <div className="rowsignup">
                        <img src={Language} alt="" />
                        <select name="language" id="language" value={input.language} onChange={handleChange} className="form-select" aria-label="Select Language">
                            <option defaultValue="Select Language">Select Language</option>
                            <option value="English">English</option>
                            <option value="Hindi">Hindi</option>
                            <option value="Marathi">Marathi</option>
                        </select>
                    </div>


                    <div className="rowsignup">
                        <img src={Gender} alt="" />
                        <select name="gender" id="gender" value={input.gender} onChange={handleChange} className="form-select" aria-label="Select Language">
                            <option defaultValue="Select Language">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>

                    <div className="startsignup">
                    <button onClick={handlesignup} >START</button>
                    </div>

                    
                </div>
            </div>
        </div>
    )
}

export default Signup
